import React from 'react';
import { Link } from 'react-router-dom';

export default class ButtonLink extends React.Component {
  render() {
    let { className = '', primary, seconday, store, modifier, role, ariaLabel = '', ...rest } = this.props;
    className = `rilrtl-button ${className}`;

    if (store) {
      if (primary || seconday) {
        className += ' rilrtl-button--luxesecondary';
      }
    } else {
      if (primary || seconday) {
        className += ' rilrtl-button--secondary';
      }
    }

    if (modifier && typeof modifier === 'string') {
      className += ` rilrtl-button--${modifier}`;
    }

    const extraProps = {};
    if (role === 'button') {
      extraProps.role = 'button';
      extraProps['aria-label'] = ariaLabel;
    }

    return (
      <Link className={className} {...rest} {...extraProps}>
        {this.props.children}
      </Link>
    );
  }
}
